/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {StatusTimelineComponent} from './status-timeline.component';
import {CommonModule} from '@angular/common';

@NgModule({
    declarations: [StatusTimelineComponent],
    imports: [
        CommonModule
    ],
    exports: [StatusTimelineComponent]
})
export class StatusTimelineModule {
}
